import { render, staticRenderFns } from "./IconPerson.vue?vue&type=template&id=74d3e106&"
import script from "./IconPerson.vue?vue&type=script&lang=js&"
export * from "./IconPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports